<template>
  <div id="app">
    <div class="bg-gray-200 font-sans leading-normal tracking-normal">
      <router-view></router-view>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// import Navbar from "@/components/Nav";
// import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    // Navbar
    // Footer
  },
  async created() {
    const getIPAddress = await fetch("https://ipapi.co/json/").then(e =>
      e.json()
    );

    if (getIPAddress) {
      fetch("/.netlify/functions/getIPAddress", {
        method: "POST",
        body: JSON.stringify(getIPAddress)
      }).then(e => e.json());
    }
  },
  methods: {
    track() {
      this.$ga.page("/");
    }
  }
};
</script>
